export default __webpack_public_path__ + "static/media/include_13_female@3x.ba23bac6.jpg";